'use client'

import { useTranslations } from 'next-intl'

import FansEmptyIllustration from '@/assets/icons/leaderboard/fans-leaderboard-empty.svg'
import Button from '@/ui/Button'

import S from './FansLeaderboardEmptyState.module.scss'

type FansLeaderboardEmptyStateProps = {
  namespace: string
  /** A non-default filter (region/sport) is active — enables the reset CTA. */
  isFiltered: boolean
  onClearFilter: () => void
}

export function FansLeaderboardEmptyState({
  namespace,
  isFiltered,
  onClearFilter
}: FansLeaderboardEmptyStateProps) {
  const t = useTranslations(namespace)

  return (
    <div className={S.root} role="status">
      <FansEmptyIllustration
        className={S.illustration}
        aria-hidden
        focusable={false}
      />
      <div className={S.text}>
        <h3 className={S.title}>{t('empty.title')}</h3>
        <p className={S.subtitle}>
          {t(isFiltered ? 'empty.subtitleFiltered' : 'empty.subtitleDefault')}
        </p>
      </div>
      {isFiltered ? (
        <Button
          type="button"
          color="color"
          size="m"
          className={S.cta}
          onClick={onClearFilter}
        >
          {t('empty.clearFilter')}
        </Button>
      ) : null}
    </div>
  )
}
